export const TypeOfImage = ["png", "jpg", "jpeg", "jfif", "jpeg"];
